<wbo-edit-page #editPage [title]="model.data.webTerminalName">
    <fui-formation-group [title]="'wbo.web-terminal.edit.formation.webTerminalDetails'">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="webTerminalName"
                                               [(ngModel)]="model.data.webTerminalName">
                        </wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-terminal-single-select-edit-control
                            formControlName="terminalId"
                            [(ngModel)]="model.data.terminalId"
                            [allowClearSelectionOption]="false"
                            [readonlyOnEdit]="true">
                        </wbo-terminal-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-single-select-edit-control formControlName="terminalType"
                                                        [(ngModel)]="model.data.terminalType" [readonlyOnEdit]="true">
                            <wbo-select-options>
                                <wbo-select-option [value]="WebTerminalType.API"
                                                   label="wbo.web-terminal.edit.option.terminal-type.api"></wbo-select-option>
                                <wbo-select-option [value]="WebTerminalType.ONLINE"
                                                   label="wbo.web-terminal.edit.option.terminal-type.online"></wbo-select-option>
                                <wbo-select-option [value]="WebTerminalType.RESERVATION"
                                                   label="wbo.web-terminal.edit.option.terminal-type.reservation"></wbo-select-option>
                                <wbo-select-option [value]="WebTerminalType.MOBILE_POS"
                                                   label="wbo.web-terminal.edit.option.terminal-type.mobile-pos"></wbo-select-option>
                                <wbo-select-option *ngIf="Plugin.TYRO | booleanConfig" [value]="WebTerminalType.TYRO"
                                                   label="wbo.web-terminal.edit.option.terminal-type.tyro"></wbo-select-option>
                                <wbo-select-option *ngIf="License.EZYPAY | booleanConfig"
                                                   [value]="WebTerminalType.EZYPAY"
                                                   label="wbo.web-terminal.edit.option.terminal-type.ezypay"></wbo-select-option>
                                <wbo-select-option *ngIf="License.TYROFOOD | booleanConfig"
                                                   [value]="WebTerminalType.TYRO_FOOD"
                                                   label="wbo.web-terminal.edit.option.terminal-type.tyro-food"></wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                    <fui-column formGroupName="site">
                        <wbo-site-single-select-edit-control formControlName="groupName" [readonlyOnEdit]="true"
                                                             [(ngModel)]="model.data.site.groupName"></wbo-site-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="storeName"
                                               [(ngModel)]="model.data.storeName"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="model.data.terminalType !== WebTerminalType.API">
                <fui-two-columns>
                    <fui-column>
                        <fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="autoRefloat"
                                                       [(ngModel)]="model.data.autoRefloat"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control formControlName="autoBalance"
                                                       [(ngModel)]="model.data.autoBalance"></wbo-checkbox-edit-control>
                        </fui-tandem-field>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="(License.EZYPAY | booleanConfig) && model.data.terminalType === WebTerminalType.EZYPAY"
                     [label]="'wbo.web-terminal.edit.field-set.ezyPayDetails'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control [(ngModel)]="model.data.externalWebTerminalId"
                                               formControlName="externalWebTerminalId"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="(Plugin.TYRO | booleanConfig) && model.data.terminalType === WebTerminalType.TYRO"
                     [label]="'wbo.web-terminal.edit.field-set.tyroDetails'">
                <fui-two-columns>
                    <fui-column formGroupName="tyroInfo">
                        <wbo-password-edit-control formControlName="terminalPassphrase"
                                                   [(ngModel)]="model.data.tyroInfo.terminalPassphrase"></wbo-password-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row *ngIf="model.data.terminalType === WebTerminalType.API"
                     [label]="'wbo.web-terminal.edit.field-set.apiDetails'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-integration-partner-single-select-edit-control
                            formControlName="integrationName"
                            [(ngModel)]="model.data.integrationName"></wbo-integration-partner-single-select-edit-control>
                        <wbo-checkbox-edit-control formControlName="suspendOrdering"
                                                   [(ngModel)]="model.data.suspendOrdering"></wbo-checkbox-edit-control>
                        <fui-column [label]="'wbo.web-terminal.edit.field-set.catalogueExport'">
                            <wbo-category-multi-select-edit-control formControlName="exportCategories"
                                                                    [(ngModel)]="model.data.exportCategories"
                                                                    [multiObjectValueType]="true"></wbo-category-multi-select-edit-control>
                        </fui-column>
                        <fui-column [label]="'wbo.web-terminal.edit.field-set.orderReadyEmail'">
                            <fui-tandem-field>
                                <wbo-checkbox-edit-control [(ngModel)]="model.data.sendOrderReadyEmail"
                                                           formControlName="sendOrderReadyEmail">
                                </wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control [(ngModel)]="model.data.sendOrderReadySms"
                                                           formControlName="sendOrderReadySms">
                                </wbo-checkbox-edit-control>
                            </fui-tandem-field>
                            <wbo-checkbox-edit-control formControlName="sendTableOrderReady"
                                                       [(ngModel)]="model.data.sendTableOrderReady"
                                                       [readonly]="!model.data.sendOrderReadyEmail && !model.data.sendOrderReadySms"></wbo-checkbox-edit-control>
                            <ng-container formGroupName="orderReadyEmail">
                                <ng-container formGroupName="emailMessage">
                                    <wbo-text-edit-control [(ngModel)]="model.data.orderReadyEmail.emailMessage.subject"
                                                           [readonly]="!model.data.sendOrderReadyEmail"
                                                           formControlName="subject">
                                    </wbo-text-edit-control>
                                    <ng-container formGroupName="emailSettings">
                                        <wbo-email-setting-single-select-edit-control formControlName="emailSettingId"
                                                                                      [(ngModel)]="model.data.orderReadyEmail.emailMessage.emailSettings.emailSettingId"
                                                                                      [objectValue]="model.data.orderReadyEmail.emailMessage.emailSettings"
                                                                                      [readonly]="!model.data.sendOrderReadyEmail">
                                        </wbo-email-setting-single-select-edit-control>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </fui-column>
                    </fui-column>
                    <fui-column>
                        <fui-column [label]="'wbo.web-terminal.edit.field-set.orderCompletion'">
                            <wbo-checkbox-edit-control [(ngModel)]="model.data.autoConvertPickupToSale"
                                                       formControlName="autoConvertPickupToSale"></wbo-checkbox-edit-control>
                            <wbo-checkbox-edit-control [(ngModel)]="model.data.autoConvertDeliveryToSale"
                                                       formControlName="autoConvertDeliveryToSale"></wbo-checkbox-edit-control>
                            <wbo-numeric-edit-control [(ngModel)]="model.data.mergeTableOrdersWithinMinutes"
                                                      formControlName="mergeTableOrdersWithinMinutes"
                                                      [notation]="'wbo.common.label.minutes' | translate"></wbo-numeric-edit-control>
                        </fui-column>
                        <fui-column [label]="'wbo.web-terminal.edit.field-set.resetPasswordEmail'"
                                    formGroupName="resetPasswordEmail">
                            <ng-container formGroupName="emailMessage">
                                <wbo-text-edit-control [(ngModel)]="model.data.resetPasswordEmail.emailMessage.subject"
                                                       formControlName="subject"></wbo-text-edit-control>
                                <ng-container formGroupName="emailSettings">
                                    <wbo-email-setting-single-select-edit-control formControlName="emailSettingId"
                                                                                  [(ngModel)]="model.data.resetPasswordEmail.emailMessage.emailSettings.emailSettingId"
                                                                                  [objectValue]="model.data.resetPasswordEmail.emailMessage.emailSettings">
                                    </wbo-email-setting-single-select-edit-control>
                                </ng-container>
                            </ng-container>
                        </fui-column>
                    </fui-column>
                </fui-two-columns>
            </fui-row>

            <!--fui-row *ngIf="model.data.terminalType === WebTerminalType.TYRO_FOOD"
                     [label]="'wbo.web-terminal.edit.field-set.tyroFoodDetails'">
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control [(ngModel)]="model.data.tyroFoodLocationId"
                                               [overrideRequired]="true"
                                               formControlName="tyroFoodLocationId"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column *ngIf="!requestingAccessToken">
                        <ng-container *ngIf="!tyroFoodRequestRefreshTokenUpdated">
                            <fui-inline-warning *ngIf="!model.data.tyroFoodRefreshToken"
                                                [title]="'wbo.common.info.warning'">
                                <span>{{'wbo.web-terminal.edit.message.tyroAuthentication.notAuthenticated' | translate}}</span>
                                <br><br>
                                <a (click)="authenticateTyro()" *ngIf="!editPageComponent?.entityRestricted" href="#"
                                   onclick="return false;">{{'wbo.web-terminal.edit.message.tyroAuthentication.authenticate' | translate}}</a>
                                <br><br>
                            </fui-inline-warning>
                            <fui-inline-information *ngIf="model.data.tyroFoodRefreshToken"
                                                    [title]="'wbo.common.info.information'">
                                <span>{{'wbo.web-terminal.edit.message.tyroAuthentication.authenticated' | translate}}</span>
                                <br><br>
                                <a (click)="authenticateTyro()" *ngIf="!editPageComponent?.entityRestricted" href="#"
                                   onclick="return false;">{{'wbo.web-terminal.edit.message.tyroAuthentication.reAuthenticate' | translate}}</a>
                                <br><br>
                            </fui-inline-information>
                        </ng-container>
                        <ng-container *ngIf="tyroFoodRequestRefreshTokenUpdated">
                            <fui-inline-information *ngIf="model.data.tyroFoodRefreshToken"
                                                    [title]="'wbo.common.info.information'">
                                <span>{{'wbo.web-terminal.edit.message.tyroAuthentication.refreshTokenUpdated' | translate}}</span>
                            </fui-inline-information>
                        </ng-container>
                    </fui-column>
                    <fui-column *ngIf="requestingAccessToken">
                        <fui-inline-information [title]="'wbo.common.info.information'">
                            <span>{{'wbo.web-terminal.edit.message.tyroAuthentication.waitingAuthentication' | translate}}</span>
                            <br><br>
                            <a (click)="cancelAuthenticationTyroPool()" href="#"
                               onclick="return false;">{{'wbo.web-terminal.edit.message.tyroAuthentication.cancelWaitingAuthentication' | translate}}</a>
                            <br><br>
                        </fui-inline-information>
                    </fui-column>
                </fui-two-columns>
            </fui-row-->
        </fui-rows>
    </fui-formation-group>
</wbo-edit-page>
